import { defineStore } from "pinia";

export const useCountryStateStore = defineStore('countryState', {
  state: () => ({
    countryState: {},
    countryStates: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setCountryState(countryState) {
      this.countryState = countryState
    },
    setCountryStates(countryStates) {
      this.countryStates = countryStates
    },
    addCountryState(countryState) {
      this.countryStates.unshift(countryState)
    },
    updateCountryState(countryState) {
      let index = this.countryStates.findIndex(cl => cl.id === countryState.id)
      this.countryStates.splice(index, 1, countryState)
    },
    deleteCountryState(countryState) {
      let index = this.countryStates.findIndex(cl => cl.id === countryState.id)
      this.countryStates.splice(index, 1)
    },
  },
});